import { ReactNode } from 'react';

import { BaseReactionProps } from '../BaseReaction';
import { RendererOptions } from '../BaseReactionSVG';

import { HoverType, SubstrateColors } from './getMolDrawers';

interface ReagentCircles {
  productCircle: ReactNode;
  substrateCircle: ReactNode;
}

const HOVER_CIRCLE_COLOR = SubstrateColors[3];

export function buildHoverCircles(props: Partial<BaseReactionProps>, options: RendererOptions): ReagentCircles {
  const { productMol } = props;
  const { alignedSubstrateMols, mapToProduct, mapToSubstrates, hoverState } = options;

  const result: any = {
    productCircle: null,
    substrateCircle: null,
  };

  const { substrateIndex, mapId, type } = hoverState;
  if (type !== HoverType.HOVER_ATOM || mapId == null || substrateIndex == null) {
    return result;
  }

  const substrateMol = alignedSubstrateMols[substrateIndex];
  if (productMol == null || substrateMol == null) {
    return result;
  }

  const productAtomId = mapToProduct[mapId];
  if (productAtomId != null && productMol.positions) {
    const productPos = productMol.positions[productAtomId];
    result.productCircle = (
      <circle cx={productPos[0]} cy={productPos[1]} r={40} fill={HOVER_CIRCLE_COLOR} opacity={0.6} />
    );
  }

  const substrateLocation = mapToSubstrates[mapId];
  if (substrateLocation != null && substrateMol.positions) {
    const substratePos = substrateMol.positions[substrateLocation[1]];
    result.substrateCircle = (
      <circle cx={substratePos[0]} cy={substratePos[1]} r={40} fill={HOVER_CIRCLE_COLOR} opacity={0.6} />
    );
  }

  return result;
}
